import { NavLink, Outlet } from "react-router-dom";
import { Link } from "react-router-dom";
import RequireAuth from "../../auth/RequireAuth";
import RequireConsent from "../../auth/RequireConsent";

const ACCOUNT_TABS = [
  { to: "/account/dashboard", label: "Dashboard" },
  { to: "/account/saved-searches", label: "Saved Searches" },
  { to: "/account/favorites", label: "Favorites" },
  { to: "/account/profile", label: "Profile" },
  { to: "/account/security", label: "Security" },
  { to: "/account/notifications", label: "Notifications" },
  { to: "/account/consents", label: "Legal & Consent" },
  { to: "/account/preferences", label: "Preferences" },
];

const AccountLayoutContent = () => (
  <div className="midpoint-app auth-page account-area-app">
    <div className="account-area-layout">
      <header className="account-security-header panel-card">
        <p className="eyebrow">Account</p>
        <h1>Your account</h1>
        <p className="muted">
          Manage saved searches, favorites, profile, sign-in methods, sessions, and preferences.
        </p>
        <nav className="account-area-tabs" aria-label="Account sections">
          {ACCOUNT_TABS.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              className={({ isActive }) =>
                `account-area-tabs__link${isActive ? " is-active" : ""}`
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>
        <p className="muted account-security-nav">
          <Link to="/">Back to map</Link>
        </p>
      </header>
      <Outlet />
    </div>
  </div>
);

const AccountLayout = () => (
  <RequireAuth>
    <RequireConsent>
      <AccountLayoutContent />
    </RequireConsent>
  </RequireAuth>
);

export default AccountLayout;
